import React from "react";
import styles from "./About.module.css";
import { useNavigate } from "react-router-dom";    
const PartnerInfo = () => {
  const navigate = useNavigate();

  const handleContactClick = () => {
    navigate("/contact");
  }
  return (
    <div className={styles.partnerInfoSection}>
      <h2 className={styles.partnerInfoHeading}>Let’s Partner for Success</h2>
      <p className={styles.partnerInfoText}>
        At Hyproc International, you gain more than just a supplier you gain a strategic partner
        <br></br>
         dedicated to optimizing your supply chain and helping your business thrive.
      </p>
      <div className={styles.partnerInfoButtons}>
        <button className={styles.newbutton} onClick={handleContactClick}>Get a Quote</button>
        <button className={styles.newbutton} onClick={handleContactClick}>Contact Us</button>
      </div>
    </div>
  );
};

export default PartnerInfo;
